// apps/landing-page/src/lib/api/progress.ts
const API_BASE = '/api/proxy';

export const progressApi = {
  /**
   * The signed-in user's completed module ids, for the P-04 progressive-unlock
   * overlay (docs/revisi-260711-founder-notes.md §3.3). Reuses the existing
   * GET /progress/summary — its `modules[]` array is already pre-filtered to
   * modules with at least one COMPLETED session (progress.service.ts
   * getModuleBreakdown), so no new endpoint is needed just to know "has this
   * user finished module X". Auth rides on the httpOnly aks_session cookie the
   * proxy forwards, same as the payment client. Returns [] for anonymous
   * visitors or a failed fetch rather than throwing — an unlock check must
   * never block catalog rendering.
   */
  async getCompletedModuleIds(): Promise<string[]> {
    try {
      const res = await fetch(`${API_BASE}/progress/summary`, {
        credentials: 'same-origin',
      });
      if (!res.ok) return [];
      const summary: { modules?: { moduleId: string }[] } = await res.json();
      return (summary.modules ?? []).map((m) => m.moduleId);
    } catch {
      return [];
    }
  },
};
